<template>
    <div>
        <button @click="closeMenu()"
                class="fixed items-center justify-end text-white z-60 pin-t pin-r m-6
                    sm:border-white rounded md:border-transparent hover:text-blue-light hover:border-blue-light"
                :class="{'bg-grey-darkest': smallScreen && !headerTransparent}">
                <IconX viewBox="0 0 24 24" class="block h-15 w-15 mx-1 my-1 z-60" />
        </button>
        <div class="flex flex-col h-screen items-end z-60">
            <div class="my-12">
                <router-link to="/warranty"
                    class="btn-header xs:text-lg md:text-base pb-2 my-6 fixed pin-r mr-6"
                    :class=" {'current-tab': $route.path === '/warranty' }"
                    title="Warranty Page"
                    aria-label="Click here to go to the Warranty page">
                    Warranty
                </router-link>
            </div>
            <div class="my-12">
                <router-link to="/car-maintenance"
                    class="btn-header xs:text-lg md:text-base pb-2 my-6 fixed pin-r mr-6"
                    :class="{ 'current-tab': $route.path === '/car-maintenance' }"
                    aria-label="Click here to go to the Car Maintenance 101 Page">
                    Car Maintenance 101
                </router-link>
            </div>
            <div class="my-12">
                <router-link to="/right-shop"
                    class="btn-header xs:text-lg md:text-base pb-2 my-6 fixed pin-r mr-6"
                    :class="{ 'current-tab': $route.path === '/right-shop' }"
                    aria-label="Click here to go to the Right Shop Page which has info on choosing the best repair shop for you">
                    Choose the Right Shop
                </router-link>
            </div>
            <div class="my-12">
                <div class="fixed w-full xs:w-64 text-right pin-r pr-6 border-t border-grey-light border-b py-8 mb-4 fixed pin-r my-12">
                    <button class="btn-header text-lg"
                        @click="$refs.modal.open()">
                        Service Center Login
                    </button>
                </div>
            </div>
        </div>
        <Modal ref="modal"
            :overlayClose="true"
            :overflow="false"
            :ariaLabelledBy="'modalTitle'"
            :ariaDescribedBy="'modalContent'">
            <div slot="title">
                <h2 id="modalTitle" class="text-xl">Member Login Moved</h2>
            </div>
            <div slot="content">
                <div id="modalContent" class="max-w-md mb-6">
                    <p class="mt-3 mb-6 mx-6 sm:mx-12 md:mx-16 text-left">
                        The Certified Auto Repair Member Administration pages have moved to our Professional site at
                        www.oreillypro.com. This move provides an updated and easier to use interface for our
                        Certified Auto Repair members. You will need to use your O'Reilly Pro login to continue.
                    </p>
                  <a :href="oreillyProUrl"
                     @click="$refs.modal.close()"
                     title="O'Reilly Pro Login"
                     aria-label="The O'Reilly Pro login for CARC members"
                     class="btn btn-white border font-semibold rounded shadow-md mx-1 w-32">
                    OK
                  </a>
                    <button @click="$refs.modal.close()"
                        class="btn-red mx-1 w-32 rounded">
                        Cancel
                    </button>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
import IconX from 'icon/x.svg';
import Modal from '@/js/components/Modal.vue';

export default {
    props: {
        headerTransparent: {
            type: Boolean,
            required: true,
            default: false
        },
        smallScreen: {
            type: Boolean,
            required: true,
            default: false
        }
    },
    components: {
        Modal,
        IconX
    },
    computed: {
        oreillyProUrl() {
            if (process.env.NODE_ENV === 'test') {
                return 'https://www-test-1.oreillypro.com/FirstCallOnline/login';
            } if (process.env.NODE_ENV === 'development') {
                return 'https://www-dev-1.oreillypro.com/FirstCallOnline/login';
            }
            return 'https://www.oreillypro.com/FirstCallOnline/login';
        }
    },
    methods: {
        closeMenu() {
            this.$emit('closeMenu');
        }
    }
};
</script>

<style>
</style>
